exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applePay{margin-bottom:40px}.applePay button{width:415px;height:50px;display:none;border-radius:4px;margin-left:auto;margin-right:auto;margin-top:20px;background-image:-webkit-named-image(apple-pay-logo-white);background-position:50% 50%;background-color:#000;background-size:60%;background-repeat:no-repeat}", ""]);

// exports
